import { createSelector } from 'reselect';

// Logic for isButtonDisabled now lives inside the form component via RFF.

const getIsEmailDuplicateMessageVisible = state =>
  state.invites.isEmailDuplicateMessageVisible;

const getIsResearchIdDuplicateMessageVisible = state =>
  state.invites.isResearchIdDuplicateMessageVisible;

const getIsSuccessMessageVisible = state =>
  state.invites.isSuccessMessageVisible;

const getIsLoading = state => state.invites.isFetching;

/**
 * 2. Modernized Selector
 * This now aggregates only API-driven states.
 * 'isButtonDisabled' is removed because it is no longer a Redux concern.
 */
const getInvite = createSelector(
  getIsLoading,
  getIsEmailDuplicateMessageVisible,
  getIsResearchIdDuplicateMessageVisible,
  getIsSuccessMessageVisible,
  (
    isLoading,
    isEmailDuplicateMessageVisible,
    isResearchIdDuplicateMessageVisible,
    isSuccessMessageVisible
  ) => ({
    isLoading,
    isEmailDuplicateMessageVisible,
    isResearchIdDuplicateMessageVisible,
    isSuccessMessageVisible
  })
);

export { getInvite };
